import { Dropdown, DropdownProps, Option } from "@faro-lotv/flat-ui";
import type { JSX } from "react";

export type AnnotationEditorTypeSelectionProps = {
  /** The label of the dropdown */
  label?: string;

  /** The value to display in the dropdown */
  value?: string;

  /** The dropdown available options */
  options: Option[];

  /** The style to apply to the dropdown */
  sx?: DropdownProps["sx"];

  /** Callback function when a new value is selected */
  onChange: DropdownProps["onChange"];

  /** Indicates if the dropdown is disabled */
  disabled?: boolean;
};

/**
 * @returns A dropdown allowing to select the type of annotation to create
 */
export function AnnotationEditorTypeSelection({
  label = "Annotation Type",
  value,
  options,
  sx,
  onChange,
  disabled,
}: AnnotationEditorTypeSelectionProps): JSX.Element {
  return (
    <Dropdown
      label={label}
      value={value}
      options={options}
      dark
      fullWidth={false}
      sx={{ width: "50%", ...sx }}
      onChange={onChange}
      disabled={disabled}
      shouldCapitalize={false}
    />
  );
}
